import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import DownloadSVG from './../../../../../Assets/icons/DownloadIconMIS.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import { TABLE_HEADERS, keyMapping } from '../../../../../constants/Unit';
import { toastSuccess } from '../../../../customComponents/customToast/Toast';
import { ToastContainer } from 'react-toastify';
import searchIcon from '../../../../../Assets/icons/searchicon.svg';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';
import { FiDownload } from 'react-icons/fi';

const UnitList = () => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({});

  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    fetchUnitData();
  }, []);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchUnitData(newPage);
  };

  const fetchUnitData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        '/unit/list',
        {
          orderBy: 'unit_id desc',
          page,
          pageSize,
          searchText: searchTerm,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      console.log(totalRecordsData, 'RECORDS');
      setTotalRecords(totalRecordsData);

      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      console.log('response', response);
      setTableData(formattedData);
      // toastSuccess("Product Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching unit list:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditButton = (rowData) => {
    console.log('rowdata>', rowData);
    navigate(`${ROUTES_NAVIGATION.UNITEDIT}`, { state: { data: rowData } });
    console.log('rowdata', rowData);
  };

  // Assume 'csvData' is the raw string response from your API
  const handleDownloadExcel = (csvData) => {
    // 1. Read the CSV string into a workbook
    const workbook = XLSX.read(csvData, { type: 'string', raw: true });
    const worksheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[worksheetName];

    // 2. Fix Column Widths (so unit names are fully displayed)
    // This sets column A to 30 chars wide, and Column B to 40 chars wide
    worksheet['!cols'] = [
      { wch: 30 }, // Width for "Unit"
      { wch: 40 }, // Width for "UnitDescription"
    ];

    // 3. Export as a real .xlsx file
    // Setting bookSST to false and type to array helps preserve string formats
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    // 4. Trigger the download
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Unit_Report.xlsx';
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : '',
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : '',
      searchText: searchTerm,
      orderBy: 'unit_id desc',
    };

    try {
      const response = await axiosInstance.post(
        '/unit/unit-report-excel',
        payload,
        {
          headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          responseType: 'text',
        },
      );
      handleDownloadExcel(response.data);
    } catch (error) {
      console.error('Error downloading Excel file:', error);
    }
  };
  useEffect(() => {
    if (searchTerm === '') {
      fetchUnitData();
    }
  }, [searchTerm]);
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="OnboardManagamentContainer">
            <div className="OnboardManagamentbuttonContainer">
              <h5>Units</h5>
            </div>
            <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
              <div
                className="topleftdataContainer"
                style={{ borderRight: '1px solid lightgrey' }}
              >
                <h5 className="listTopDataValueText">{totalData} </h5>
                <h6>All Unit</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: '1px solid lightgrey' }}
              >
                <h5 className="listTopDataValueText">{totalActive} </h5>
                <h6>Active Unit</h6>
              </div>
              <div className="topleftdataContainer">
                <h5 className="listTopDataValueText">{totalInactive} </h5>
                <h6>Inactive Unit</h6>
              </div>
              <button
                className="addcustomerbutton"
                onClick={() => navigate(ROUTES_NAVIGATION.UNITADD)}
              >
                Add Unit
              </button>
            </div>
          </div>

          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className="listsearchContainer">
                <h5>Unit List</h5>
                <div>
                  <SearchInput
                    placeholder="Search Unit"
                    onSearch={fetchUnitData}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <div
                  onClick={downloadExcel}
                  className="flte-btnnn"
                  style={{ borderRadius: '38px', cursor: 'pointer' }}
                >
                  Export
                  <span>
                    {/* <img
                                   onClick={downloadExcel}
                                   src={DownloadSVG}
                                   alt="downloadSvg"
                                   className="downloadexcel-misreportsales"
                                   style={{
                                     // paddingTop: "9rem",
                                     // paddingRight: "1rem",
                                     
                                     cursor: "pointer",
                                     height:"24px"
                                   }}
                                 /> */}
                    <FiDownload
                      className="downloadexcel-misreportsales"
                      style={{ cursor: 'pointer' }}
                      size={22}
                    />
                  </span>
                </div>
              </div>
            </div>

            <CustomTable
              data={tableData}
              headers={TABLE_HEADERS}
              keyMapping={keyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEditButton}
              totalRecords={totalRecords}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default UnitList;
